module.exports = __webpack_public_path__ + "static/img/www.7ccadb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/www.png
// module id = Sqvm
// module chunks = 0